// extracted by mini-css-extract-plugin
export default {"showDetailedButton":"styles_showDetailedButton__8dCFp","showDetailedArrow":"styles_showDetailedArrow__i0aHg","showDetailedArrowActive":"styles_showDetailedArrowActive__R8qC6"};